import styled, { css, RuleSet } from 'styled-components';
import { FlexCenterAligned, arrow } from '../../../styled/common';
import { Typography } from '../Typography';
import { CloseButtonAlignType } from '../Modal/types';
import { HeaderPosition } from './types';

export const Header = styled(FlexCenterAligned)<{
  height: number;
  showHeaderBorder: boolean;
  headerPosition: HeaderPosition;
  $styles?: RuleSet<object>;
}>`
  position: ${({ headerPosition }) => headerPosition};
  padding: 0 15px;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  height: ${({ height }) => height}px;
  z-index: 99;
  -webkit-backface-visibility: hidden;

  ${({ showHeaderBorder }) =>
    showHeaderBorder &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    `}

  @media screen and (min-width: ${({ theme }) =>
    `calc(${theme.tabletBreakpoint} + 1px)`}) {
    padding-right: 25px;
    padding-left: 25px;
  }
  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    height: 65px;
    padding-right: 40px;
    padding-left: 40px;
  }

  ${({ $styles }) => $styles};
`;

export const HeaderLeftAction = styled.div<{
  closeButtonAlign: CloseButtonAlignType;
}>`
  top: 0;
  position: absolute;
  height: 100%;
  width: 60px;
  ${({ closeButtonAlign }) => css`
    ${closeButtonAlign === 'left' ? 'left: 0;' : 'right: 0;'}
  `}

  @media screen and (min-width: ${({ theme }) =>
    `calc(${theme.tabletBreakpoint} + 1px)`}) {
    ${({ closeButtonAlign }) => css`
      ${closeButtonAlign === 'right' && 'right: 10px;'}
    `}
  }

  @media screen and (min-width: ${({ theme }) =>
      `calc(${theme.desktopBreakpoint} + 1px)`}) {
    ${({ closeButtonAlign }) => css`
      ${closeButtonAlign === 'right' && 'right: 25px;'}
    `}
  }
`;

const buttonStyles = css`
  position: absolute;
  padding: 10px 15px;
  height: 100%;
  width: 100%;
  vertical-align: middle;
  background: transparent;
  text-align: center;
  left: 0;
  top: 0;
`;

export const HeaderBackButton = styled.button`
  white-space: nowrap;
  background-repeat: no-repeat;
  background-position: left 15px center;
  background-size: 4vw;
  ${buttonStyles};

  ${({ theme }) =>
    arrow({
      size: '12px',
      fill: theme.colors.text.secondary,
      bw: '2px',
      angle: '135deg'
    })}
`;

export const HeaderCloseButton = styled.button`
  ${buttonStyles};
`;

export const HeaderTitleWrapper = styled(FlexCenterAligned)`
  gap: 5px;

  @media screen and (min-width: ${({ theme }) =>
      `calc(${theme.tabletBreakpoint} + 1px)`}) {
    text-align: left;
    display: block;
    width: 100%;
  }
`;

export const HeaderTitle = styled(Typography)`
  margin: 0;
  text-align: center;
`;

export const HeaderRightAction = styled.div`
  top: 0;
  right: 15px;
  position: absolute;
  height: 100%;
`;

export const HeaderBottom = styled(FlexCenterAligned)`
  padding-bottom: 10px;
`;
